import React from 'react';
import { useTranslation } from 'react-i18next';

import DataBlock from '../data-block/DataBlock';

import scss from './PredictedMessage.module.scss';

function PredictedMessage({ message, isLoading }) {
  const { t } = useTranslation('genie');
  const { message: messageText, interest, action, uncertainty, count, error } = message;

  return (
    <div className={scss.message}>
      <span className={scss.mark}>{t('alternative')}</span>
      <span className={scss.idCell}>{count}</span>
      <span className={scss.textCell}>{messageText}</span>
      <DataBlock r1={interest} r2={action} certainty={uncertainty} error={error} isLoading={isLoading} />
    </div>
  );
}

export default PredictedMessage;
